import styled from "styled-components";

import log from '@/images/month-log-btn.png'
import presenter from '@/images/month-presenter-btn.png'

const View = styled.div`
  position: absolute;
  left: 0;
  top: 1300px;
  width: 100%;
  height: 320px;
  text-align: center;

  & > p:nth-child(1) {
    font-size: 14px;
    line-height: 22px;
    color: #033085;
    position: absolute;
    width: 100%;
    left: 0;
    top: -60px;
    cursor: auto;
  }

  & > p:nth-child(2) {
    font-size: 16px;
    line-height: 28px;
    color: #033085;
    position: absolute;
    width: 100%;
    left: 0;
    top: 40px;
  }

  div.log {
    position: absolute;
    right: 145px;
    top: 40px;
    background-image: url(${log});
    width: 80px;
    height: 22px;
    cursor: pointer;
  }

  div.presenter {
    position: absolute;
    cursor: pointer;
    right: 50px;
    top: 40px;
    background-image: url(${presenter});
    width: 80px;
    height: 22px;
  }

  ul {
    width: 100%;
    text-align: center;

    li {
      display: inline-block;
      width: 113px;
      margin: 80px 20px;
      line-height: 28px;
      font-size: 14px;
      color: #033085;
      p{
        margin: 0 -30px;
      }
    }
  }

  div.discount {
    position: absolute;
    bottom: 20px;
    left: 30%;
    // background-image: url(\${discount});
    // width: 168px;
    // height: 58px;
    // cursor: pointer;
    // transition: all 0.3s;
    // &:hover{
    //   background-image: url(\${discountHover});
    // }
  }

  div.origin {
    position: absolute;
    bottom: 20px;
    right: 30%;
    //background-image: url(\${origin});
    //width: 168px;
    //height: 58px;
    // cursor: pointer;
    // transition: all 0.3s;
    // &:hover{
    //   background-image: url(\${originHover});
    // }
  }
`;

export {
  View
}
